import * as React from 'react'

function ArrowDown({size = 24}) {
  return (
		<div className="rounded-full h-14 w-14 flex items-center justify-center border-2 border-current hover:border-current cursor-pointer animate-bounce hover:bounceOrig m-auto">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-current w-8 h-8"
      >
        <path d="M12 5v13M5 12l7 7 7-7" />
      </svg>
    </div>
  )
}

export {ArrowDown}